//@flow
import MktgStore from './mktgStoreClass';

export default new MktgStore();
